export enum FleetActionNames {
  LOAD_FLEET_LOGO_URL_REQUEST = 'LOAD_FLEET_LOGO_URL_REQUEST',
  LOAD_FLEET_LOGO_URL_SUCCEEDED = 'LOAD_FLEET_LOGO_URL_SUCCEEDED',
  LOAD_FLEET_LOGO_URL_FAILED = 'LOAD_FLEET_LOGO_URL_FAILED',
  ERROR_ALERT_FLEET_LOGO = 'ERROR_ALERT_FLEET_LOGO',
  UPLOAD_FLEET_LOGO = 'UPLOAD_FLEET_LOGO',
  DELETE_FLEET_LOGO_REQUEST = 'DELETE_FLEET_LOGO_REQUEST',
}

export interface LoadFleetLogoUrlRequest {
  type: FleetActionNames.LOAD_FLEET_LOGO_URL_REQUEST;
  payload: string;
}

export interface LoadFleetLogoUrlSucceeded {
  type: FleetActionNames.LOAD_FLEET_LOGO_URL_SUCCEEDED;
  payload: string | null;
}
export interface DeleteFleetLogoRequest {
  type: FleetActionNames.DELETE_FLEET_LOGO_REQUEST;
}

export interface LoadFleetLogoUrlError {
  type: FleetActionNames.LOAD_FLEET_LOGO_URL_FAILED;
}

export interface UploadFleetLogo {
  type: FleetActionNames.UPLOAD_FLEET_LOGO;
  payload: Blob;
}

export interface AlertErrorUpload {
  type: FleetActionNames.ERROR_ALERT_FLEET_LOGO;
  payload: Error;
}

export type FleetAction = LoadFleetLogoUrlRequest | LoadFleetLogoUrlSucceeded | LoadFleetLogoUrlError;
